import React from 'react';
import { isMobile } from 'react-device-detect';
import IvrForm from './ivrForm';
import DialerForm from './dialerForm';
import MaskyooForm from './maskyooForm';

export default function CallbackForm(props) {

    const contentData = props?.data?.contentData;
    const callbackMobileProvider = contentData?.callbackMobileProvider;
    const callbackDesktopProvider = contentData?.callbackDesktopProvider;
    const failureText = contentData.failureText;

    // CallbackIvr
    const callbackIvrForm = props.data?.callbackIvrForm;
    const {
        callbackIvrFormTitle,
        callbackIvrFormSubTitle,
        callbackIvrFormSuccessTitle,
        callbackIvrFormSuccessSubTitle,
    } = contentData;

    // Callback Dialer
    const directCallPhone = contentData?.directCallPhone;
    const {
        callbackDialerFormTitle,
        callbackDialerFormSubTitle,
    } = contentData;

    let currentView = null;

    if (isMobile) {
        if (callbackMobileProvider == 'IVR') {
            currentView = (
                <IvrForm
                    showSuccess={props.data?.showSuccess}
                    showError={props.data?.showError}
                    title={callbackIvrFormTitle}
                    subtitle={callbackIvrFormSubTitle}
                    successTitle={callbackIvrFormSuccessTitle}
                    successSubtitle={callbackIvrFormSuccessSubTitle}
                    failureText={failureText}
                    phone={callbackIvrForm.phone}
                    errors={callbackIvrForm.errors}
                    onPhoneChange={phone => props.actions.setPhoneCallbackIvr(phone)}
                    onSubmit={props.actions.createIvrCallback} />
            )
        }
        else if (callbackMobileProvider == 'DirectCall') {
            currentView = (
                <DialerForm
                    title={callbackDialerFormTitle}
                    subtitle={callbackDialerFormSubTitle}
                    phone={directCallPhone} />
            )
        }
        else if (callbackMobileProvider == 'Maskyoo') {
            currentView = (
                <MaskyooForm
                    title={callbackDialerFormTitle}
                    subtitle={callbackDialerFormSubTitle}
                    onStartLoading={props.actions.showAppLoader}
                    onFinishLoading={props.actions.hideAppLoader} />
            )
        }
    }
    else { // Desktop
        if (callbackDesktopProvider == 'IVR') {
            currentView = (
                <IvrForm
                    showSuccess={props.data?.showSuccess}
                    showError={props.data?.showError}
                    title={callbackIvrFormTitle}
                    subtitle={callbackIvrFormSubTitle}
                    successTitle={callbackIvrFormSuccessTitle}
                    successSubtitle={callbackIvrFormSuccessSubTitle}
                    failureText={failureText}
                    phone={callbackIvrForm.phone}
                    errors={callbackIvrForm.errors}
                    onPhoneChange={phone => props.actions.setPhoneCallbackIvr(phone)}
                    onSubmit={props.actions.createIvrCallback} />
            )
        }
    }

    return currentView;
}